// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_mainContainer__pEeez {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.styles_historyBar__gvPS1 {
  width: 100%;
  border-radius: 50px;
  padding: 0.5rem;
  background-color: #fff;
  color: #18316e;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.styles_historyBar__gvPS1:hover {
  background-color: #e2f2ff;
}

.styles_titleModule__historyBar__0Q5CF {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.styles_h1__historyBar__wCuze {
  font-size: 1rem;
  font-weight: 500;
  color: #18316e;
}

.styles_textTipo__Xw2gN {
  color: #757575;
  font-weight: 500;
}

.styles_attContainer__THboH {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.styles_data__module__7ig3a {
  text-align: center;
  background-color: #e2f2ff;
  font-size: 11px;
  color: #000;
  border-radius: 14px;
  padding: 5px;
}

.styles_msg__module__JI\\+k\\+ {
  text-align: center;
  font-size: 0.8rem !important;
  background-color: #18316e;
  font-size: 1rem;
  color: #fff;
  border-radius: 1rem;
  padding: 0.5rem;
}

.styles_header__moduleContainer__w4CXZ {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.styles_header__moduleContainer__w4CXZ h1 {
  font-family: 'Inter';
  font-size: 1.2rem;
  color: #18316e;
  padding: 0.5rem;
}

.styles_body__moduleContainer__o2NBH {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto;
  max-height: 8rem;
  padding: 0.5rem;
}

.styles_campo__body__8tMMA {
  min-height: 3rem;
  width: 100%;
  padding: 0.5rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.styles_campo__body__8tMMA span {
  font-weight: 500;
  color: #18316e;
}

.styles_valor__campo__XBqkP {
  width: 40%;
  text-align: right;
}



.styles_downloadBtn__campo__2Zn29 {
  font-size: 0.8rem;
  display: flex;
  gap: 0.2rem;
  justify-content: center;
  align-items: center;
  background-color: #18316e;
  color: #fff;
  padding: 0.5rem;
  border-radius: 20rem;
  height: 2rem;
}

.styles_downloadBtn__campo__2Zn29:hover {
  font-weight: 600;
  cursor: pointer;
}

@media (max-width: 768px) {
  .styles_attContainer__THboH {
    flex-direction: column;
    width: 50%;
  }

  .styles_campo__body__8tMMA span {
    font-size: 0.8rem;
  }

  .styles_downloadBtn__campo__2Zn29 {
    font-size: 0.6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Juridico/HistoricoTimeline/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;;;AAIA;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".mainContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.historyBar {\n  width: 100%;\n  border-radius: 50px;\n  padding: 0.5rem;\n  background-color: #fff;\n  color: #18316e;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n\n.historyBar:hover {\n  background-color: #e2f2ff;\n}\n\n.titleModule__historyBar {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.h1__historyBar {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #18316e;\n}\n\n.textTipo {\n  color: #757575;\n  font-weight: 500;\n}\n\n.attContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.data__module {\n  text-align: center;\n  background-color: #e2f2ff;\n  font-size: 11px;\n  color: #000;\n  border-radius: 14px;\n  padding: 5px;\n}\n\n.msg__module {\n  text-align: center;\n  font-size: 0.8rem !important;\n  background-color: #18316e;\n  font-size: 1rem;\n  color: #fff;\n  border-radius: 1rem;\n  padding: 0.5rem;\n}\n\n.header__moduleContainer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.header__moduleContainer h1 {\n  font-family: 'Inter';\n  font-size: 1.2rem;\n  color: #18316e;\n  padding: 0.5rem;\n}\n\n.body__moduleContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 1rem;\n  overflow-y: auto;\n  max-height: 8rem;\n  padding: 0.5rem;\n}\n\n.campo__body {\n  min-height: 3rem;\n  width: 100%;\n  padding: 0.5rem;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #fff;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.campo__body span {\n  font-weight: 500;\n  color: #18316e;\n}\n\n.valor__campo {\n  width: 40%;\n  text-align: right;\n}\n\n\n\n.downloadBtn__campo {\n  font-size: 0.8rem;\n  display: flex;\n  gap: 0.2rem;\n  justify-content: center;\n  align-items: center;\n  background-color: #18316e;\n  color: #fff;\n  padding: 0.5rem;\n  border-radius: 20rem;\n  height: 2rem;\n}\n\n.downloadBtn__campo:hover {\n  font-weight: 600;\n  cursor: pointer;\n}\n\n@media (max-width: 768px) {\n  .attContainer {\n    flex-direction: column;\n    width: 50%;\n  }\n\n  .campo__body span {\n    font-size: 0.8rem;\n  }\n\n  .downloadBtn__campo {\n    font-size: 0.6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `styles_mainContainer__pEeez`,
	"historyBar": `styles_historyBar__gvPS1`,
	"titleModule__historyBar": `styles_titleModule__historyBar__0Q5CF`,
	"h1__historyBar": `styles_h1__historyBar__wCuze`,
	"textTipo": `styles_textTipo__Xw2gN`,
	"attContainer": `styles_attContainer__THboH`,
	"data__module": `styles_data__module__7ig3a`,
	"msg__module": `styles_msg__module__JI+k+`,
	"header__moduleContainer": `styles_header__moduleContainer__w4CXZ`,
	"body__moduleContainer": `styles_body__moduleContainer__o2NBH`,
	"campo__body": `styles_campo__body__8tMMA`,
	"valor__campo": `styles_valor__campo__XBqkP`,
	"downloadBtn__campo": `styles_downloadBtn__campo__2Zn29`
};
export default ___CSS_LOADER_EXPORT___;
